import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export default function Header({ getLabel, jobsCount, filteredTaxonomies, taxonomies, pictures }) {
	const [domNode, setDomNode] = useState(null);
	const headerRef = useRef(null);

	useEffect(() => {
		// Set the target container
		setDomNode(document.querySelector('.jobs-header'));
	}, []);

	const getHeaderText = () => {
		let baseLabel;

		if (Object.keys(filteredTaxonomies).length) {
			// If a filter is active
			if (jobsCount === 0) {
				return getLabel('no_results');
			} else if (jobsCount === 1) {
				baseLabel = getLabel('filtered_single');
			} else {
				baseLabel = getLabel('filtered_multiple');
			}
		} else {
			// Unfiltered
			baseLabel = jobsCount === 1 ? getLabel('unfiltered_single') : getLabel('unfiltered_multiple');
		}

		let openPositionsVar = jobsCount === 1 ? getLabel('var_open_position') : getLabel('var_open_positions');
		openPositionsVar = openPositionsVar.replace('[job_count]', `<span class="job-count">${jobsCount}</span>`);
		let headerText = baseLabel.replace('[open_positions]', '<span class="open-positions">' + openPositionsVar + '</span>');

		Object.keys(taxonomies).forEach((taxonomyName) => {
			if (taxonomyName in filteredTaxonomies) {
				const filterTerm = taxonomies[taxonomyName].terms.find((item) => item.slug === filteredTaxonomies[taxonomyName])?.name;

				headerText = headerText.replace(`[${taxonomyName}]`, getLabel(`var_${taxonomyName}`).replace(`[${taxonomyName}]`, filterTerm));
			} else {
				headerText = headerText.replace(`[${taxonomyName}]`, '');
			}
		});

		return headerText.trim();
	};

	const getCouch = () => {
		let couch = pictures.couch;

		if (filteredTaxonomies['scope']) {
			const couchByFilter = taxonomies['scope'].terms.find((term) => term.slug === filteredTaxonomies['scope']).couch;

			if (couchByFilter?.webp && couchByFilter?.png) {
				couch = couchByFilter;
			}
		}

		return (
			<CSSTransition key={filteredTaxonomies['scope'] ?? 'default'} timeout={2000} classNames="couch">
				<picture key={filteredTaxonomies['scope'] ?? 'default'}>
					<source srcSet={couch.webp} type="image/webp" />
					<source srcSet={couch.png} type="image/png" />
					<img src={couch.png} alt="Couch" />
				</picture>
			</CSSTransition>
		);
	};

	return domNode
		? ReactDOM.createPortal(
				<>
					<div className="highlight" data-fill="c-light-primary" />
					<hgroup>
						<h1>{getLabel('headline')}</h1>
						<p className="text-subline" dangerouslySetInnerHTML={{ __html: getHeaderText() }}></p>
					</hgroup>
					<div className="jobs-header__visual" ref={headerRef}>
						<TransitionGroup className="couch">{getCouch()}</TransitionGroup>
					</div>
				</>,
				domNode,
			)
		: null;
}

Header.propTypes = {
	getLabel: PropTypes.func.isRequired,
	jobsCount: PropTypes.number.isRequired,
	filteredTaxonomies: PropTypes.object.isRequired,
	taxonomies: PropTypes.object.isRequired,
	pictures: PropTypes.object.isRequired,
};
